// Polska liczba mnoga: 1 słówko, 2–4 słówka, 5+ słówek (i 12–14, 22–24 → „many” tylko dla 12–14).
export function plPlural(n: number, one: string, few: string, many: string): string {
  const a = Math.abs(Math.trunc(n));
  if (a === 1) return one;
  const last = a % 10;
  const lastTwo = a % 100;
  return last >= 2 && last <= 4 && !(lastTwo >= 12 && lastTwo <= 14) ? few : many;
}
